// The join intent: the layout routes it to the join form or the upgrade modal.
export const JOIN_INTENT_URL = '/community?modal=community_join';

// Where every post-purchase authentication hop (SSO, OTP, sign-in modal) lands:
// back on the join intent, flagged so the modal derives the accept step.
export const SUCCESS_REDIRECT_TO = `${JOIN_INTENT_URL}&upgrade_return=1`;
